import {
  Companion_getInstance29f2rub45de3p as Companion_getInstance,
  UserMembership38xnkdta6uihl as UserMembership,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MemberRole1167ovv8tjumm as MemberRole } from './enums.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(UserMembership_contractor_getInstance());
}
function get_role(_this__u8e3s4) {
  return _this__u8e3s4.prop(UserMembership_role_getInstance());
}
function prepareUserMembershipFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [UserMembership_contractor_getInstance(), UserMembership_role_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function UserMembership_contractor$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function UserMembership_contractor$_get_name_$ref_nv8h34() {
  return (p0) => p0.i20();
}
function UserMembership_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UserMembership_contractor$_get_serializer_$ref_lg3yvt() {
  return (p0) => p0.h2j();
}
function UserMembership_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function UserMembership_contractor$_get_annotations_$ref_9hph3f() {
  return (p0) => p0.bz();
}
var UserMembership_contractorClass;
function UserMembership_contractor() {
  if (UserMembership_contractorClass === VOID) {
    class $ {
      constructor() {
        UserMembership_contractor_instance = this;
        var tmp = this;
        tmp.c8c_1 = lazy(UserMembership_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d8c_1 = lazy(UserMembership_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e8c_1 = lazy(UserMembership_contractor$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UserMembership_contractor$_get_name_$ref_nv8h34(), null);
        return tmp0.f2();
      }
      f8c(receiver) {
        return receiver.g8c_1;
      }
      k2j(receiver) {
        return this.f8c(receiver instanceof UserMembership() ? receiver : THROW_CCE());
      }
      i8c(receiver, value) {
        return receiver.j8c(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UserMembership() ? receiver : THROW_CCE();
        return this.i8c(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UserMembership_contractor$_get_serializer_$ref_lg3yvt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UserMembership_contractor$_get_annotations_$ref_9hph3f(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'UserMembership_contractor', VOID, VOID, [SerializableProperty()]);
    UserMembership_contractorClass = $;
  }
  return UserMembership_contractorClass;
}
var UserMembership_contractor_instance;
function UserMembership_contractor_getInstance() {
  if (UserMembership_contractor_instance === VOID)
    new (UserMembership_contractor())();
  return UserMembership_contractor_instance;
}
function UserMembership_role$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function UserMembership_role$_get_name_$ref_x3w0m9() {
  return (p0) => p0.i20();
}
function UserMembership_role$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UserMembership_role$_get_serializer_$ref_8whxtk() {
  return (p0) => p0.h2j();
}
function UserMembership_role$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function UserMembership_role$_get_annotations_$ref_o8p5ys() {
  return (p0) => p0.bz();
}
var UserMembership_roleClass;
function UserMembership_role() {
  if (UserMembership_roleClass === VOID) {
    class $ {
      constructor() {
        UserMembership_role_instance = this;
        var tmp = this;
        tmp.k8c_1 = lazy(UserMembership_role$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l8c_1 = lazy(UserMembership_role$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m8c_1 = lazy(UserMembership_role$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.k8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UserMembership_role$_get_name_$ref_x3w0m9(), null);
        return tmp0.f2();
      }
      f8c(receiver) {
        return receiver.h8c_1;
      }
      k2j(receiver) {
        return this.f8c(receiver instanceof UserMembership() ? receiver : THROW_CCE());
      }
      n8c(receiver, value) {
        return receiver.j8c(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UserMembership() ? receiver : THROW_CCE();
        return this.n8c(tmp, value instanceof MemberRole() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UserMembership_role$_get_serializer_$ref_8whxtk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UserMembership_role$_get_annotations_$ref_o8p5ys(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'UserMembership_role', VOID, VOID, [SerializableProperty()]);
    UserMembership_roleClass = $;
  }
  return UserMembership_roleClass;
}
var UserMembership_role_instance;
function UserMembership_role_getInstance() {
  if (UserMembership_role_instance === VOID)
    new (UserMembership_role())();
  return UserMembership_role_instance;
}
//region block: exports
export {
  get_contractor as get_contractor238fhmgszzker,
  prepareUserMembershipFields as prepareUserMembershipFields2je7h0x74xy12,
  get_role as get_role1cuv52bfv4mxp,
};
//endregion

//# sourceMappingURL=UserMembershipFields.mjs.map
